import React from 'react';
import * as S from './style';

export function getMoveTypeDiscription(moveType: string): React.ReactElement {
    if (moveType === 'small_move') {
        return (
            <>
                <div>거주자 3인 이상</div>
                <div>1톤 3대 혹은 5톤 이상</div>
            </>
        );
    } else if (moveType === 'family_move') {
        return (
            <>
                <div>거주자 3인 이상</div>
                <div>1톤 3대 혹은 5톤 이상</div>
            </>
        );
    } else {
        return <></>;
    }
}

export function getMovTypeeName(moveType: string): string {
    
    switch(moveType) {
        case 'small_move': return '소형이사';
        case 'family_move': return '소형이사';
        default: return '';
    }
}

export interface Props {
    active: boolean;
    moveType: string;
    onClick?: () => void;
}

function BtnMoveType({ active, moveType, onClick }: Props): React.ReactElement {
    return (
        <S.ButtonMoveType active={active} onClick={onClick}>
            <S.MoveType active={active}>{getMovTypeeName(moveType)}</S.MoveType>
            <S.MoveTypeDescription active={active}>{getMoveTypeDiscription(moveType)}</S.MoveTypeDescription>
        </S.ButtonMoveType>
    );
}
export default BtnMoveType;
